// extracted by mini-css-extract-plugin
export default {"container":"FilterSection_container__m+Dox","filters":"FilterSection_filters__mPTbh"};